//@flow
import * as Immutable from 'immutable';

import { TeamId } from 'common/models/flow/TeamId';
import type { TeamIdModelType } from 'common/models/flow/TeamId';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

class InternalTeamId extends TeamId {
    static fromJS(json: TeamIdModelType): InternalTeamId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    static getTeamIdsValidationMessage({
        teamIds,
        validTeams
    }: {
        teamIds: Immutable.List<TeamId>,
        validTeams: Immutable.List<string>
    }) {
        const invalidTeams = teamIds.filter(
            team => !validTeams.includes(team.teamId)
        );
        if (invalidTeams.size > 0) {
            const invalidTeamIds = invalidTeams
                .map(team => team.teamId)
                .join(', ');
            return nsTranslate('invalidTeamId', {
                invalidTeamIds,
                count: invalidTeams.size
            });
        }
    }
}

export { InternalTeamId as TeamId };
